<template>
  <div class="card p-0 shadow position-relative my-2">
    <span class="pills-image pill-1" />
    <span class="pills-image pill-2" />
    <span class="pills-image pill-3" />

    <div
      class="card-body rounded-4 transition-shadow py-4
      box-shadow-pink-300 box-shadow-hover-pink-300"
    >
      <div class="row">
        <div class="col-12 col-md-10 mx-auto">
          <h3>
            Partager votre code
          </h3>
          <div class="d-flex flex-column">
            <div
              v-for="(entry, index) in emails"
              :key="index"
              class="d-flex align-items-end gap-2 mt-2"
            >
              <div class="flex-grow-1">
                <v-input
                  label="E-mail"
                  placeholder="nicolas.moreau@gmail.com"
                  :value="entry.email"
                  action-module="sponsorship"
                  :path="`new[${index}].email`"
                  :validation="validateEmail"
                />
              </div>
              <button
                v-if="index > 0"
                type="button"
                class="btn-close mb-3"
                aria-label="Supprimer"
                @click="removeEmail(index)"
              />
            </div>
            <button
              class="btn btn-add-email text-primary text-decoration-none mt-2 align-self-start"
              type="button"
              @click="addEmail"
            >
              + Ajouter un autre email
            </button>
            <button
              type="button"
              class="btn btn-primary my-3 w-50 mx-auto"
              :disabled="!isValid || isLoading"
              @click="sendInvitations"
            >
              <span v-if="isLoading">Envoi en cours...</span>
              <span v-else>
                Envoyer votre invitation
                <font-awesome-icon icon="envelope" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Input from '@/components/common/input/Input.vue';
import { validateEmail } from '@/utils/validators';

export default {
  name: 'SponsorshipInviteForm',
  components: {
    'v-input': Input,
  },
  data() {
    return {
      isLoading: false,
      validateEmail,
    };
  },
  computed: {
    emails() {
      return this.$store.getters['sponsorship/new'];
    },
    isValid() {
      return this.emails.some((e) => validateEmail(e.email));
    },
  },
  mounted() {
    this.$store.dispatch('sponsorship/setValue', { new: [] });
    this.$store.dispatch('sponsorship/addNewEmpty');
  },
  methods: {
    addEmail() {
      this.$store.dispatch('sponsorship/addNewEmpty');
    },
    removeEmail(index) {
      const updated = this.emails.filter((_, i) => i !== index);
      this.$store.dispatch('sponsorship/setValue', { new: updated });
    },
    async sendInvitations() {
      this.isLoading = true;
      try {
        await this.$store.dispatch('sponsorship/pushNewSponsorship');
        this.$router.push('/client/perks/sponsorship/confirmation');
      } catch {
        // error handled by store/api layer
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
h3 {
  font-size: 1.5rem;
  font-weight: 600 !important;
}

.pills-image {
  height: 12px;
  border-radius: 60px;
  position: absolute;
  z-index: 3;
}

.pill-1 {
  top: 25%;
  right: 30px;
  width: 39px;
  height: 8px;
  background-color: var(--bs-yellow-300);
}

.pill-2 {
  bottom: 17%;
  right: 30px;
  width: 30px;
  background-color: var(--bs-green-300);
}

.pill-3 {
  bottom: 20%;
  left: 40px;
  width: 32px;
  background-color: var(--bs-blue-300);
}

.btn-add-email:focus,
.btn-add-email:active {
  outline: none;
  box-shadow: none;
}
</style>
